import { type FC } from "react";

import FullscreenLayout from "@/pages/layouts/FullScreenLayout";
import { Button } from "@/shared/components/ui/button";

interface LawyerApplicationPendingProps {
  onSignOut: () => void;
}

export const LawyerApplicationPending: FC<LawyerApplicationPendingProps> = ({ onSignOut }) => {
  return (
    <FullscreenLayout
      className="bg-[#f6f2f1] overflow-hidden"
      childrenContainerClassName="h-screen flex items-center justify-center p-8"
    >
      <div className="w-[600px] max-w-[90vw] bg-white rounded-2xl shadow-[0_20px_50px_rgba(12,18,28,0.1)] overflow-hidden">
        <div className="p-12">
          <h1 className="text-3xl font-medium text-stone-900 mb-6 leading-tight">
            Application Pending
          </h1>
          <p className="text-stone-600 mb-6">
            Your lawyer application is still pending review by our admin team.
          </p>
          <p className="text-stone-600 mb-8">
            You will be notified once your account has been approved. Please check back later.
          </p>
          <Button onClick={onSignOut} variant="outline" className="w-full h-12">
            Sign Out
          </Button>
        </div>
      </div>
    </FullscreenLayout>
  );
};
